/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Revertscheduledchange2Inputs */

const en_revertscheduledchange2 = /** @type {(inputs: Revertscheduledchange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo scheduled change`)
};

const de_revertscheduledchange2 = /** @type {(inputs: Revertscheduledchange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wechsel rückgängig machen`)
};

/**
* | output |
* | --- |
* | "Undo scheduled change" |
*
* @param {Revertscheduledchange2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const revertscheduledchange2 = /** @type {((inputs?: Revertscheduledchange2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Revertscheduledchange2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_revertscheduledchange2(inputs)
	return de_revertscheduledchange2(inputs)
});
export { revertscheduledchange2 as "revertScheduledChange" }